// CARTO basemap tile URL construction.
//
// Since 25 Sep 2026 CARTO serves an "API KEY REQUIRED" placeholder tile for
// any basemaps.cartocdn.com request without a valid `?key=` parameter
// (https://carto.com/basemaps/apikey). The key is injected at build time from
// the VITE_CARTO_API_KEY environment variable (GitHub Actions secret
// CARTO_API_KEY in the deploy job). It is never hard-coded in the repo.
//
// The key is necessarily visible in browser tile requests; restrict it to the
// production host in the CARTO Basemaps dashboard (Referer restriction).

/** Dark Matter style (same visual style the map has always used). */
export const CARTO_STYLE = 'dark_all';

/**
 * Documented CARTO raster path (`/rastertiles/<style>/...`), subdomain form,
 * with Leaflet's `{r}` retina suffix (`@2x` on HiDPI screens).
 */
// Kept as a plain literal (no interpolation) so the deploy job can grep the
// built bundle for it; basemap.test.ts asserts it matches CARTO_STYLE.
export const CARTO_TILE_BASE =
  'https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}{r}.png';

export const CARTO_SUBDOMAINS = 'abcd';

/** Attribution required by CARTO's terms: must stay visible on the map. */
export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

/**
 * Build the Leaflet tile URL template. With a key, appends `?key=<encoded>`.
 * Without a key (local dev / PR validation builds only; production builds
 * fail in vite.config.ts), returns the keyless URL so tiles show CARTO's
 * placeholder and logs a console warning.
 */
export function cartoTileUrl(key: string | undefined | null): string {
  const k = (key ?? '').trim();
  if (!k) {
    if (typeof console !== 'undefined') {
      console.warn(
        '[basemap] VITE_CARTO_API_KEY is not set; CARTO tiles will show the "API KEY REQUIRED" placeholder. ' +
          'Set VITE_CARTO_API_KEY for local builds; production builds require it.',
      );
    }
    return CARTO_TILE_BASE;
  }
  return `${CARTO_TILE_BASE}?key=${encodeURIComponent(k)}`;
}
